import type { ComponentProps, ReactElement } from 'react';
import { Children } from 'react';
import type { ColumnPropTypes } from '@george-labs.com/design-system/types/components/Table';
import type { WrapperFC } from '@george-labs.com/design-system';
import { TableRow } from '@george-labs.com/design-system';

import type { ResponsiveTableCell } from './ResponsiveTableCell';

type Cell = ReactElement<ComponentProps<typeof ResponsiveTableCell>>;

interface Props extends ComponentProps<typeof TableRow> {
    children: Cell | Cell[];
    columns: ColumnPropTypes[];
}

export const ResponsiveTableRow: WrapperFC<Props> = ({
    children: cells,
    columns,
    ...tableRowProps
}) => {
    const cellsByColumnId: Record<string, Cell> = {};
    const pickColumn = ({ id }: ColumnPropTypes) => cellsByColumnId[id];

    Children.forEach(cells, (cell) => {
        cellsByColumnId[cell.props.columnId] = cell;
    });

    // eslint-disable-next-line react/jsx-props-no-spreading
    return <TableRow {...tableRowProps}>{columns.map(pickColumn)}</TableRow>;
};

ResponsiveTableRow.wrapsComponent = TableRow;
